(() => {
  const hasRequestedVariant = new URLSearchParams(window.location.search).has('variant');
  const initialise = (container = document) => {
    container.querySelectorAll('[data-thrila-motion]').forEach((button) => {
        if (button.dataset.ready) return;
        button.dataset.ready = 'true';
        button.addEventListener('click', () => {
          const offer = button.closest('[data-thrila-cooler]');
          const paused = offer.dataset.paused !== 'true';
          offer.dataset.paused = String(paused);
          button.setAttribute('aria-pressed', String(paused));
          button.setAttribute('aria-label', paused ? button.dataset.resumeLabel : button.dataset.pauseLabel);
          button.querySelector('[data-pause-icon]').hidden = paused;
          button.querySelector('[data-play-icon]').hidden = !paused;
        });
    });
    container.querySelectorAll('[data-thrila-landing]').forEach((root) => {
      if (['motocross', 'bmx'].includes(root.dataset.thrilaLanding) && !root.dataset.sizingReady) {
        const headingTemplate = root.querySelector('template[data-thrila-sizing-heading]');
        if (headingTemplate) {
          root.dataset.sizingReady = 'true';
          let heading;
          const syncSizing = () => {
            const control = Array.from(root.querySelectorAll('.tpo_open-modal-button')).find((button) => /^size\s+guide\s*[-–:]\s*(?:jersey|bmx|motocross)/i.test(button.textContent.trim()));
            const container = control?.closest('.tpo_option-container');
            if (!container) {
              heading?.remove();
              root.removeAttribute('data-thrila-native-sizing');
              return;
            }
            if (!heading?.isConnected) heading = headingTemplate.content.firstElementChild.cloneNode(true);
            if (heading.nextElementSibling !== container) container.before(heading);
            if (!root.hasAttribute('data-thrila-native-sizing')) root.setAttribute('data-thrila-native-sizing', 'true');
          };
          syncSizing();
          const sizingObserver = new MutationObserver(syncSizing);
          sizingObserver.observe(root, { childList: true, subtree: true });
          document.addEventListener('shopify:section:unload', (event) => {
            if (event.target.contains(root)) sizingObserver.disconnect();
          }, { once: true });
        }
      }
      if (['motocross', 'bmx'].includes(root.dataset.thrilaLanding) && root.dataset.kitDisabled !== 'true' && !root.dataset.kitReady) {
        root.dataset.kitReady = 'true';
        let picker;
        let cards = [];
        let nativeControl;
        let nativeInput;
        let defaultApplied = false;
        const parseAmount = (text) => {
          const number = text.replace(/[^0-9.,-]/g, '');
          const separator = Math.max(number.lastIndexOf('.'), number.lastIndexOf(','));
          const decimal = separator >= 0 && number.length - separator - 1 <= 2;
          return Number(decimal ? number.slice(0, separator).replace(/[.,]/g, '') + '.' + number.slice(separator + 1) : number.replace(/[.,]/g, ''));
        };
        const sync = () => {
          if (!nativeControl?.isConnected) {
            // Easify uses "Select" for motocross and "SELECT" for BMX.
            const input = root.querySelector('.tpo_dropdown input[name="properties[Select]" i]');
            const control = input?.closest('.tpo_dropdown');
            const buttons = Array.from(control?.querySelectorAll('button.tpo_option-type-selection') || []);
            const options = buttons.map((button) => {
              const name = button.querySelector('.tpo_option_type_label')?.textContent.trim() || '';
              const kind = /combo/i.test(name) ? 'combo' : /pant.*only/i.test(name) ? 'pant' : /jersey.*only/i.test(name) ? 'jersey' : '';
              return { button, name, kind };
            });
            if (options.length !== 3 || new Set(options.map((option) => option.kind)).size !== 3 || options.some((option) => !option.kind)) return;
            const priceBlock = root.querySelector('.product-block--price');
            if (!priceBlock) return;
            picker?.remove();
            nativeControl = control;
            nativeInput = input;
            picker = document.createElement('div');
            picker.className = 'thrila-kit-picker product-block';
            picker.setAttribute('role', 'group');
            picker.setAttribute('aria-label', root.dataset.kitLabel);
            const heading = document.createElement('p');
            heading.className = 'thrila-kit-heading';
            heading.textContent = root.dataset.kitLabel;
            picker.append(heading);
            const grid = document.createElement('div');
            grid.className = 'thrila-kit-grid';
            picker.append(grid);
            const money = new Intl.NumberFormat(document.documentElement.lang || 'en-AU', { style: 'currency', currency: root.dataset.kitCurrency || 'AUD', currencyDisplay: 'narrowSymbol' });
            cards = ['jersey', 'pant', 'combo'].map((kind) => {
              const option = options.find((candidate) => candidate.kind === kind);
              const card = document.createElement('button');
              card.type = 'button';
              card.className = 'thrila-kit-card';
              card.dataset.kitChoice = kind;
              card.setAttribute('aria-pressed', 'false');
              const title = document.createElement('strong');
              title.textContent = root.dataset[kind + 'Label'];
              const price = document.createElement('span');
              price.className = 'thrila-kit-price';
              const surcharge = parseAmount(option.button.querySelector('.tpo_additional-price')?.textContent || '');
              price.textContent = money.format(Number(root.dataset.kitBasePrice) / 100 + surcharge);
              card.append(title, price);
              card.addEventListener('click', () => {
                const current = Array.from(nativeControl.querySelectorAll('button.tpo_option-type-selection')).find((button) => button.querySelector('.tpo_option_type_label')?.textContent.trim() === option.name);
                current?.click();
                requestAnimationFrame(sync);
              });
              grid.append(card);
              return { card, option };
            });
            const riderQuote = root.querySelector('.thrila-rider--bmx, .thrila-rider--motocross');
            if (riderQuote && riderQuote.parentElement === priceBlock.parentElement) riderQuote.after(picker);
            else priceBlock.after(picker);
            control.classList.add('thrila-native-kit-control');
            control.closest('.tpo_option-container')?.classList.add('thrila-native-kit-container');
          }
          nativeInput = nativeControl.querySelector('input[name="properties[Select]" i]');
          if (!defaultApplied) {
            defaultApplied = true;
            if (!nativeInput.value) {
              const combo = cards.find(({ option }) => option.kind === 'combo');
              if (combo && !combo.option.button.disabled) {
                combo.card.click();
                return;
              }
            }
          }
          cards.forEach(({ card, option }) => {
            option.button = Array.from(nativeControl.querySelectorAll('button.tpo_option-type-selection')).find((button) => button.querySelector('.tpo_option_type_label')?.textContent.trim() === option.name) || option.button;
            const selected = String(nativeInput.value.startsWith(option.name));
            if (card.getAttribute('aria-pressed') !== selected) card.setAttribute('aria-pressed', selected);
            const disabled = option.button.disabled;
            if (card.disabled !== disabled) card.disabled = disabled;
          });
        };
        sync();
        const observer = new MutationObserver(sync);
        observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'disabled', 'value'] });
        root.addEventListener('change', sync);
        document.addEventListener('shopify:section:unload', (event) => {
          if (event.target.contains(root)) observer.disconnect();
        }, { once: true });
      }
      if (root.dataset.thrilaLanding !== 'apparel') return;
      const useTeeDefaults = Boolean(root.querySelector('.thrila-product-sizing__charts a[href="/pages/size-guide#mens-tee"]')) || root.dataset.productHandle === 'box-tee';
      let variants = [];
      if (useTeeDefaults) {
        try { variants = JSON.parse(root.querySelector('[data-variant-json]')?.textContent || '[]'); }
        catch (_) { /* Keep the native availability state if product JSON is absent. */ }
      }
      root.querySelectorAll('[data-thrila-size-guide]').forEach((button) => {
        if (button.dataset.ready) return;
        button.dataset.ready = 'true';
        const dialog = root.querySelector('[data-thrila-size-dialog]');
        const content = root.querySelector('[data-thrila-chart]').content.cloneNode(true);
        const children = Array.from(content.childNodes);
        const guideIndex = children.findIndex((node) => /^(?:(?:tee|tank)\s+)?size\s+(?:guides?|charts?)\s*:?$/i.test(node.textContent.trim()));
        if (guideIndex > 0) children.slice(0, guideIndex).forEach((node) => node.remove());
        dialog.querySelector('[data-thrila-chart-content]').append(content);
        button.addEventListener('click', () => dialog.showModal());
        dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
      });
      root.querySelectorAll('fieldset.variant-input-wrap[data-handle="size"]').forEach((fieldset) => {
        if (fieldset.dataset.thrilaReady) return;
        fieldset.dataset.thrilaReady = 'true';
        const inputs = Array.from(fieldset.querySelectorAll('input[type="radio"]'));
        const isYouth = (input) => /^(youth|kids?|child|y\d)/i.test(input.value.trim());
        const youth = inputs.filter(isYouth);
        const adults = inputs.filter((input) => !isYouth(input));
        const isAvailable = (input) => {
          if (input.disabled || input.classList.contains('disabled') || input.nextElementSibling?.classList.contains('disabled')) return false;
          if (!variants.length) return true;
          const otherOptions = Array.from(root.querySelectorAll('[data-variant-input]')).filter((option) => option.dataset.index !== input.dataset.index && (option.type !== 'radio' || option.checked));
          return variants.some((variant) => variant.available && variant[input.dataset.index] === input.value && otherOptions.every((option) => variant[option.dataset.index] === option.value));
        };
        const preferredSize = (candidates) => candidates.find((input) => /^(?:large|l|youth\s*12|y12)$/i.test(input.value.trim()) && isAvailable(input)) || candidates.find(isAvailable);
        const selectSize = (input) => {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        };
        const labels = { XSmall: 'XS', Small: 'S', Medium: 'M', Large: 'L', XLarge: 'XL' };
        inputs.forEach((input) => {
          const label = input.nextElementSibling;
          if (label && label.tagName === 'LABEL') {
            label.textContent = labels[input.value] || input.value.replace(/^Youth\s+/i, 'Y');
            label.setAttribute('aria-label', input.value);
          }
        });
        if (useTeeDefaults && !hasRequestedVariant) {
          const initial = preferredSize(adults);
          if (initial && !initial.checked) selectSize(initial);
        }
        if (!youth.length || !adults.length) return;
        const group = document.createElement('div');
        group.className = 'thrila-age-range';
        group.setAttribute('role', 'group');
        group.setAttribute('aria-label', root.dataset.rangeLabel);
        let range = isYouth(inputs.find((input) => input.checked) || inputs[0]) ? 'youth' : 'adult';
        const update = (select) => {
          if (select) {
            const candidates = range === 'youth' ? youth : adults;
            const current = candidates.find((input) => input.checked);
            if (!current) {
              const next = useTeeDefaults ? preferredSize(candidates) : candidates.find((input) => !input.disabled && !input.classList.contains('disabled')) || candidates[0];
              if (!next) return false;
              selectSize(next);
            }
          }
          inputs.forEach((input) => { input.closest('.variant-input').dataset.thrilaSizeHidden = String(isYouth(input) !== (range === 'youth')); });
          group.querySelectorAll('button').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.range === range)));
          return true;
        };
        ['adult', 'youth'].forEach((value) => {
          const button = document.createElement('button');
          button.type = 'button'; button.dataset.range = value;
          button.textContent = value === 'adult' ? root.dataset.adultLabel : root.dataset.youthLabel;
          button.addEventListener('click', () => {
            const previous = range;
            range = value;
            if (!update(true)) range = previous;
          });
          group.append(button);
        });
        fieldset.parentElement.prepend(group);
        fieldset.addEventListener('change', (event) => {
          if (!inputs.includes(event.target)) return;
          range = isYouth(event.target) ? 'youth' : 'adult'; update(false);
        });
        update(false);
      });
    });
  };
  // Impulse emits this after its native variant and purchase-form handlers are ready.
  document.addEventListener('page:loaded', () => initialise());
  if (document.readyState === 'complete') initialise();
  else window.addEventListener('load', () => initialise(), { once: true });
  document.addEventListener('shopify:section:load', (event) => setTimeout(() => initialise(event.target), 0));
})();



